<template>
  <component :is="rootTag"
             v-if="isCurrentState || show"
             class="state-wrapper">
    <slot v-bind="manager.functionality" />
  </component>
</template>

<script>
export default {
  name: "StateWrapper",
  props: {
    name: {
      type: String,
      default: "default",
    },
    rootTag: {
      type: String,
      default: "div",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    manager: {
      default () {
        throw new Error( "A state wrapper must be within a <state-manager>" );
      },
    },
  },
  computed: {
    isCurrentState () {
      let stateName = null;

      if ( this.manager.currentState ) {
        stateName = this.manager.currentStateName;
      }

      return stateName === this.name;
    },
  },
  created () {
    this.manager.registerState( this.name );
  },
  destroyed () {
    this.manager.deregisterState( this.name );
  },
};
</script>
